"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var isDDSynthetics = function isDDSynthetics() {
  return window._DATADOG_SYNTHETICS_BROWSER === true;
};
var _default = exports["default"] = isDDSynthetics;